import axios from 'axios'
import store from '../store'
import router from '../router'
import {storeCompanyInfo, storeUserInfo} from './common'
// import { message } from 'ant-design-vue'

const request = ({
  baseURL,
  headers
}) => {
  const instance = axios.create({
    baseURL,
    timeout: 500000,
    headers
  })

  // request interceptor
  instance.interceptors.request.use(config => {
    const data = config.data;
    let accesstokens = '-1'
    if(storeCompanyInfo() != null){
      accesstokens = storeCompanyInfo().accessToken || '-1'
    }

    // 处理 headers 中token问题
    const headers = config.headers
    let token = storeUserInfo().token || ''
    if ((data && config.headers && config.headers.module && config.headers.module === 'toolset')) {
      if (accesstokens === '-1') {
        // token = storeUserInfo().token
      } else {
        token = token + '##' + accesstokens || ''
      }
    }
    config.headers = {
      token,
      ...headers
    }
    return config
  }, error => {
    // Do something with request error
    console.log(error)
    return Promise.reject(error)
  })

  // response interceptor
  instance.interceptors.response.use(response => {
    const { config: { baseURL }, data } = response
    // 如果成功直接返回接口数据
    // 单点登陆处理
    if (data.code === 'W_100005' || data.code === 'W_100004') {
      store.dispatch('loginAction', {
        userInfo: {},
        isLogin: false,
        token: '',
        tokenTimeout: 0
      })
      sessionStorage.setItem('isLogin', false)
      sessionStorage.removeItem('userInfo')

      switch (data.code) {
        case 'W_100004':
          // message.error('登录超时，请重新登录。')
          break
        case 'W_100005':
          // message.error('您的帐号在另一个地点/设备登录，您已被迫下线。如非本人操作，建议立即修改密码。')
          break
      }
      router.push('/login')
    }

    // tradeApi 逻辑 start
    const tradeApi = process.env.VUE_APP_TRADE
    if (tradeApi === baseURL) {
      const tradeData = data.data
      if ((tradeData.code === '0' && tradeData.success) || tradeData.data || tradeData) {
        return Promise.resolve(tradeData.data || tradeData)
      } else if (!tradeData.success && tradeData.message) {
        console.log(tradeData.message)
        // message.error(tradeData.message)
        return Promise.reject(tradeData.message)
      } else {
        return Promise.reject(tradeData)
      }
    }
    // tradeApi 逻辑  end
    return Promise.resolve(data)
    // return response
  }, error => {
    // Do something with response error
    return Promise.reject(error)
  })

  return instance
}

export default request
